import "./ExpandedMultilineTextFormatter.css";
import React from 'react';
import { getTextFormatterValue, TextFormatter } from '../TextFormatter';
import { Richtext, RichTextPopup } from "../../inputs/RichTextInput";
import { css, IconButton } from "office-ui-fabric-react";
import { Field } from "../../../../entities/Metadata";
import { RichTextValue } from "../../inputs/RichTextInput/common";

type Props = {
    isMultiline?: boolean;
    isMultichoice?: boolean;
    withNavigation?: boolean;
    value?: string[] | string | Richtext | null;
    urlTextMaxLen?: number;
    hideTitle?: boolean;
    hideShowMore?: boolean;
    className?: string;
    withPopupView?: boolean;
    field?: Field;
};

export const ExpandedMultilineTextFormatter = (props: Props) => {
    const [isCollapsed, setIsCollapsed] = React.useState(true);

    const value = React.useMemo(() => getTextFormatterValue(props.value, props.isMultichoice), [props.value, props.isMultichoice]);

    return <>
        <TextFormatter {...props}
            className={css(props.className, isCollapsed && !props.hideShowMore ? 'collapsed' : '')}
            showLinkAsIcon
            hideTitle={!isCollapsed}
        />
        {!!value && !props.hideShowMore && <div className='buttons-panel'>
            <span aria-hidden={true} data-selection-disabled
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setIsCollapsed(!isCollapsed);
                }}
            >{isCollapsed ? "Show more" : "Show less"}</span>
        </div>}
        {!!props.withPopupView && !!props.isMultiline
            && <RichTextPopupButton field={props.field} value={props.value} />}
    </>;
}

const RichTextPopupButton = (props: {
    value?: string[] | string | Richtext | null,
    field?: Field
}) => {
    const [showPopup, setShowPopup] = React.useState(false);

    return <>
        <IconButton data-selection-disabled
            className="richtext-view-button"
            iconProps={{ iconName: "View" }}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setShowPopup(!showPopup);
            }}
        />
        {showPopup && <RichTextPopup 
            value={props.value as RichTextValue}
            field={props.field}
            readOnly
            onPopupDismiss={() => setShowPopup(false)}
        />}
    </>;
}